var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "#535151",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95752 0.699714H8.8037L4.58298 4.92248C4.4463 5.05916 4.4463 5.28152 4.58298 5.4182C4.6503 5.48552 4.74006 5.5202 4.82982 5.5202C4.91958 5.5202 5.00933 5.48552 5.07665 5.4182L9.29942 1.19543V3.04162C9.29942 3.23541 9.4565 3.39249 9.64826 3.39249C9.84206 3.39249 9.99914 3.23541 9.99914 3.04162V0.350877C9.99914 0.157079 9.84206 0 9.64826 0H6.95752C6.76372 0 6.60664 0.157079 6.60664 0.350877C6.60868 0.542636 6.76372 0.699714 6.95752 0.699714Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09914 10H7.89882C9.05753 10 9.99796 9.05753 9.99796 7.90086V5.16932C9.99796 4.97552 9.84088 4.82048 9.64708 4.82048C9.45328 4.82048 9.29825 4.97756 9.29825 5.16932V7.89882C9.29825 8.66993 8.66993 9.29825 7.89882 9.29825H2.09914C1.32803 9.29825 0.699714 8.66993 0.699714 7.89882V3.29253V2.10118C0.699714 1.33007 1.32803 0.701754 2.09914 0.701754H4.8062C5 0.701754 5.15504 0.544676 5.15504 0.350877C5.15504 0.157079 4.99796 0 4.8062 0H2.09914C0.940433 0 0 0.942472 0 2.09914V3.29049V7.89882C0 9.05753 0.942472 10 2.09914 10Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIc);
export default __webpack_public_path__ + "static/media/open-ic.bb864c94486c9f6d7bdfdf0aedfcf1d0.svg";
export { ForwardRef as ReactComponent };